// extracted by mini-css-extract-plugin
export default {"test":"Authorization_test__dv7M1","wrapper":"Authorization_wrapper__FNYv4"};